import React, { useState, useEffect, useRef } from "react";
import { ScrollbarWrapper } from "../../../../../../components/ScrollbarWrapper";

const getWeekDays = () => {
    const days = ["M", "T", "W", "T", "F", "S", "S"];
    return days;
};

const getDaysInMonth = (year, month) => {
    const date = new Date(year, month, 1);
    const days = [];
    const firstDay = (date.getDay() === 0 ? 7 : date.getDay()) - 1;

    for (let i = 0; i < firstDay; i++) {
        days.push(null);
    }

    while (date.getMonth() === month) {
        days.push(new Date(date).getDate());
        date.setDate(date.getDate() + 1);
    }

    return days;
};

const DatePicker = ({ name, label, value, disabled, onChange, required, error, hint, widthSize, disabledWeekdays = [], disablePast = false,  disableFuture = false, }) => {
    const [dateValue, setDateValue] = useState(value);
    const [datePickerOpen, isDatePickerOpen] = useState(false);
    const [yearDropdownOpen, isYearDropdownOpen] = useState(false);
    const currentDate = new Date();
    const [dateValueDMY, setDateValueDMY] = useState(value);
    const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());
    const [searchTerm, setSearchTerm] = useState("");
    const selectRef = useRef(null);
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const currentYear = currentDate.getFullYear();
    let years = [];
    const today = new Date();
    const todayDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();
    const daysInMonth = getDaysInMonth(year, month);
    const weekDays = getWeekDays();
    let hasReachedToday = true;
    let blockAfterToday = false;

    if (disablePast) {
        hasReachedToday = false;
    }
    // console.log(value);
    // console.log(dateValueDMY);

    for (let i = 0; i <= currentYear - 1950; i++) {
        years[i] = `${currentYear - i}`;
    }

    const formatDateToDMY = (value) => {
        const parts = value.split("-");

        const year = parts[0];
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);

        return `${day < 10 ? `0${day}` : day}.${month < 10 ? `0${month}` : month}.${year}.`;
    };

    const datePickerToggle = () => {
        isDatePickerOpen(!datePickerOpen);
    };

    const yearDropdownToggle = () => {
        isYearDropdownOpen(!yearDropdownOpen);
    };

    const handleDateChange = (date) => {
        setDateValue(date);
        onChange({ target: { name, value: date } });
        isDatePickerOpen(false);
    };

    const handleDateDMY = (day, month, year) => {
        setDateValueDMY(`${day < 10 ? `0${day}` : day}.${month < 10 ? `0${month}` : month}.${year}.`);
    };

    const handleSelectYear = (year) => {
        setSelectedYear(year);
        isYearDropdownOpen(false);
    };

    const filteredYears = years.filter((year) => year.toLowerCase().includes(searchTerm.toLowerCase()));

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            isDatePickerOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            <label htmlFor={`input-${name}`} className={`${required ? "input-required" : ""}`}>
                {label}
            </label>
            <div class={`main-content__form-group main-content__form-group--dropdown ${disabled ? "datepicker-disabled" : ""}`} style={{ width: widthSize }}>
                <div class="dropdown dropdown--select dropdown--select--datepicker" ref={selectRef}>
                    <i class="fa-light fa-calendar-lines"></i>
                    <input
                        type="text"
                        className="date-input"
                        value={dateValueDMY}
                        onChange={(e) => {
                            if (disabled) return;
                            const inputDate = e.target.value;
                            setDateValueDMY(inputDate);

                            const parts = inputDate.split(".");
                            if (parts.length === 3) {
                                const [day, month, year] = parts.map(Number);
                                if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
                                    setDateValue(`${year}-${month}-${day}`);
                                    onChange({ target: { name, value: `${year}-${month}-${day}` } });
                                }
                            }
                        }}
                        placeholder={value !== "" ? formatDateToDMY(value) : ""}
                        onClick={datePickerToggle}
                    />
                    <div class={`dropdown__menu ${datePickerOpen ? "active" : ""}`}>
                        <div class="dropdown dropdown--select">
                            <div class="dropdown__toggle" onClick={yearDropdownToggle}>
                                <span>{selectedYear}</span>
                            </div>
                            <div class={`dropdown__menu ${yearDropdownOpen ? "active" : ""}`}>
                                <input type="text" class="dropdown__menu__search" placeholder="Search year" onChange={handleSearchChange} />
                                <ScrollbarWrapper
                                    id="mainContentScrollbar"
                                    className="dropdown__menu__wrap"
                                    options={{
                                        removeXTrack: true,
                                    }}
                                >
                                    {years.map((year) => {
                                        return (
                                            <div
                                                className="dropdown__menu__item"
                                                data-value={year}
                                                key={year}
                                                onClick={() => handleSelectYear(year)}
                                                style={{ display: year.toLowerCase().includes(searchTerm.toLowerCase()) ? "" : "none" }}
                                            >
                                                <span>{year}</span>
                                            </div>
                                        );
                                    })}
                                </ScrollbarWrapper>
                            </div>
                        </div>
                        <ScrollbarWrapper
                            className="dropdown__menu__wrap main-content__calendar"
                            options={{
                                removeXTrack: true,
                            }}
                        >
                            <div class="calendar-container">
                                {monthNames.map((monthName, index) => {
                                    const daysInMonth = getDaysInMonth(selectedYear, index);
                                    const monthIndex = index + 1;
                                    return (
                                        <div className="month">
                                            <div class="month-header">
                                                {monthName} {selectedYear}
                                            </div>
                                            <div class="weekdays">
                                                {weekDays.map((day) => (
                                                    <div>{day}</div>
                                                ))}
                                            </div>
                                            <div class="days">
                                                {daysInMonth.map((day, index) => {
                                                    const dateStr = `${selectedYear}-${monthIndex}-${day}`;
                                                    const isToday = dateStr === todayDate;
                                                    if (isToday) {
                                                        hasReachedToday = true;
                                                        blockAfterToday = false;
                                                    }
                                                    const dayOfWeek = index % 7;
                                                    let isDisabled = !hasReachedToday || (hasReachedToday && disabledWeekdays.includes(dayOfWeek));
                                                    if (disableFuture && blockAfterToday) {
                                                        isDisabled = true;
                                                    }
                                                    const dayClass = `day${day ? " active" : ""} ${todayDate === `${selectedYear}-${monthIndex}-${day}` ? " current-day" : ""} ${isDisabled ? "disabled-day" : ""}`;
                                                    
                                                    if (disableFuture && isToday) {
                                                        blockAfterToday = true;
                                                    }
                                                    return (
                                                        <div
                                                            key={index}
                                                            className={dayClass}
                                                            onClick={() => {
                                                                if (disabled) return;
                                                                handleDateDMY(day, monthIndex, selectedYear);
                                                                handleDateChange(
                                                                    `${selectedYear}-${monthIndex < 10 ? `0${monthIndex}` : monthIndex}-${day < 10 ? `0${day}` : day}`,
                                                                );
                                                            }}
                                                        >
                                                            {day}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </ScrollbarWrapper>
                    </div>
                </div>
            </div>

            {/* <input
                type="text"
                name={name}
                id={`input-${name}`}
                value={value}
                onChange={onChange}
                className={`input-disabled ${disabled ? "inactive" : ""} `}
                disabled={disabled}
            /> */}
            {hint && <div className="hint-message-text">{hint}</div>}
            {error && <div className="error-message-text">{error}</div>}
        </>
    );
};

export default DatePicker;
